import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { productSwitchConfig } from "../../../environments/environment";
import { LoginService } from "../../service/login.service";

@Component({
    selector: 'app-product-switch',
    template: ''
})
export class ProductSwitchComponent implements OnInit {

  private readonly loginService = inject(LoginService);
  private readonly route = inject(ActivatedRoute);

  ngOnInit(): void {
    this.route.queryParams.subscribe(async (params) => {
      const inApp = params['inApp'] ?? params['InApp'];
      if (inApp) {
        productSwitchConfig.redirectUri =
          productSwitchConfig.redirectUri + '?inApp=true';
      }
    });

    this.loginService.login(productSwitchConfig);
  }
}
